export default "__VITE_ASSET__Cr9au6b$__"